import Grid from 'styled-components-grid';
import styled from 'styled-components';

const CardGrid = styled(Grid)`
  margin: 0 ${({theme}) => theme.spacingHorizontal(-1)};
  flex: 1;
  overflow: hidden;
`;

export default CardGrid;
